<dialog-header [dialogRef]="dialogRef" headerKey="FAILURES_HISTORY"></dialog-header>
<div mat-dialog-content>
  <failure-item
    *ngFor="let item of data; index as i; let last = last"
    [showDate]="true"
    [index]="i"
    [last]="last"
    [item]="item"
    (editFailureEvent)="previewFailure($event)"
  ></failure-item>
</div>

